<template>
  <div :class="!isMobile ? 'categories' : 'menu'">
      <ul>
        <li ><a :class="{ active: currentCategory == 'all'}" @click="change('all')" href="javascript:;">Tümü</a></li>

        <li v-for="item in _.sortBy(getCategories, 'sort')" v-show="(_.find(providers, ['provider', currentProvider]) && _.find(providers, ['provider', currentProvider]).producer_id && _.find(providers, ['provider', currentProvider]).producer_id == item.producer_id) || item.producer_id == '0'">
          <a :class="{ active: currentCategory == item.id}" @click="change(item.id)" href="javascript:;" >
            {{ item.name }} 
          </a>
        </li>
      </ul>
  </div>
</template>
<script>
  import Search from './Search'
  export default{
    methods:{
      changeCategory(){
      }
    },
    computed:{
      categories(){
        return this.$store.getters['casino/getCurrentCategories'];
      },
      providers(){
        return this.$store.getters['casino/getProviders'];
      },
      currentProvider(){
        return this.$store.getters['casino/getCurrentProvider'];
      },
      currentCategory(){
        return this.$store.getters['casino/getCurrentCategory'];
      },
      getCategories(){
        return this.$store.getters['casino/getCategories'];
      },
    },
    components:{
      Search
    },  
    methods:{
      change(provider){
        this.$emit('menuChange', 'games');
        this.$store.dispatch('casino/changeCategory', [provider])
      }
    }
  }
</script>